import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreRoutingModule } from './core-routing.module';
import { CoreComponent } from './core.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './login/login.component';
import { InvitationPageComponent } from './invitation-page/invitation-page.component';
import { VerifyComponent } from './verify/verify.component';



@NgModule({
  declarations: [
    CoreComponent,
    LandingPageComponent,
    LoginComponent,
    InvitationPageComponent,
    VerifyComponent,
  ],
  imports: [
    CommonModule,
    CoreRoutingModule,
    SharedModule,
  ]
})
export class CoreModule { }
